export const environments = [
  {
    name: "Production",
    contractAddress: "0xDF686c48A8Cc5dF43c2b5b3086c4d77E9463Cac0",
  },
  {
    name: "Development",
    contractAddress: "0x40EC0E5FB2d22C1Bbf00662635eF8D20E22E8560",
  },
];

export const network = {
  ipfs: "https://ipfs.infura.io/ipfs",
  rpc: "https://goerli.infura.io/v3/a4ba4d26c1a145999d11d2630ac5eb3c",
  baseExplorerAPI: "https://goerli.etherscan.io",
};
